import { faCamera } from '@fortawesome/pro-solid-svg-icons/faCamera';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FlexGap, FlexAlign, FlexJustify, StackHorizontal } from '@ukpostbox/frontend-framework';
import { faMobileAlt } from '@fortawesome/pro-solid-svg-icons/faMobileAlt';
import { BatteryTypeEntryType } from '../../Types/ForwardingBatchTypes';
import { BatteryEntry } from './BatteryEntry';

function LithiumBatteryInEquipment(props: BatteryTypeEntryType) {
	return (
		<BatteryEntry
			name='lithiumBatteriesInEquipment'
			media={
				<StackHorizontal
					gap={FlexGap.ExtraSmall}
					align={FlexAlign.Center}
					justify={FlexJustify.Center}
					extraClass='mb-lg'
				>
					<FontAwesomeIcon icon={faMobileAlt} size='3x' />
					<FontAwesomeIcon icon={faCamera} size='3x' />
				</StackHorizontal>
			}
			title='Installed in Equipment'
			description={[{ value: 'No Powerbanks', important: true }]}
			defaultSelected={props.defaultSelected}
			callBack={(state) => props.onChangeCallback(state)}
			complete={props.complete}
			readOnly={props.readOnly}
		/>
	);
}

export { LithiumBatteryInEquipment };
